export default function SkeletonProductList() {
  return (
    <div className='mx-auto w-full max-w-sm'>
      <div className='space-y-4'>
        {/* Image skeleton */}
        <div className='aspect-square animate-pulse rounded-lg bg-gray-300'></div>

        {/* Product title skeleton */}
        <div className='h-6 animate-pulse rounded bg-gray-300'></div>

        {/* Price skeleton */}
        <div className='h-4 w-1/4 animate-pulse rounded bg-gray-300'></div>
      </div>
    </div>
  );
}
